module.exports = __webpack_public_path__ + "img/logo.0adbc9a1.svg";